export const isManagedOAuthRequest = (
  url: string | undefined,
  managedBaseUrls: Array<string | undefined>,
) => {
  if (!url || url.startsWith('/')) return true;
  return managedBaseUrls.some((baseUrl) => baseUrl && url.startsWith(baseUrl));
};
